import { useCallback } from 'react';
import useGlobalModal from 'hooks/useGlobalModal';
import * as track from 'lib/gaTracking/crossPageEvents';
import { downloadInvoiceErrorModalProps } from './DownloadInvoiceErrorModal';

export const useDownloadInvoiceErrorModal = () => {
  const { showModal } = useGlobalModal();

  return useCallback(() => {
    track.invoiceDownloadFailedModalOpened();
    showModal({
      ...downloadInvoiceErrorModalProps,
      onClose: ({ actionButtonClicked }) => {
        track.invoiceDownloadFailedModalClosed(actionButtonClicked);
      },
    });
  }, [showModal]);
};
